<img src="/Logic%20Icon.svg" alt="BridgeHire Logo" [attr.width]="size" [attr.height]="size" class="bridge-hire-logo" />